"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var analytics_1 = require("./analytics");
var component_1 = require("./component");
var uitk_react_layout_grid_1 = require("uitk-react-layout-grid");
var uitk_react_button_1 = require("uitk-react-button");
var utils_1 = require("./utils");
var RedirectBannerV1 = (function (_super) {
    __extends(RedirectBannerV1, _super);
    function RedirectBannerV1(props) {
        var _this = _super.call(this, props) || this;
        _this.hideBannerDialog = function () {
            _this.setState({
                showBannerDialogV1: false
            });
        };
        _this.redirectToTargetPOS = function () {
            var redirectHref = _this.state.redirectHref;
            _this.paUtility.trackBannerAction(utils_1.ReferrerType.TRACK_SUBMIT_BANNER);
            window.location.href = redirectHref || '';
        };
        var analytics = _this.props.bannerModelV1.analytics;
        _this.state = { showBannerDialogV1: true, redirectHref: '' };
        _this.paUtility = new analytics_1.PlatformAnalyticsUtility(analytics);
        _this.stayOnSamePageAndTrack = _this.stayOnSamePageAndTrack.bind(_this);
        return _this;
    }
    RedirectBannerV1.prototype.componentDidMount = function () {
        this.getMIDAppendedURL();
    };
    RedirectBannerV1.prototype.render = function () {
        var bannerModelV1 = this.props.bannerModelV1;
        var showBannerDialogV1 = this.state.showBannerDialogV1;
        if (bannerModelV1 && Object.keys(bannerModelV1).length > 0 && showBannerDialogV1) {
            return (React.createElement("div", { className: "redirect-banner-designV2 uitk-flex uitk-flex-align-items-center" },
                React.createElement("div", { className: "uitk-flex-grow-1" },
                    React.createElement(uitk_react_layout_grid_1.UitkLayoutGrid, { columns: { small: 4, medium: 8, large: 12, extra_large: 12 }, space: "four", alignItems: "center", alignContent: "center" },
                        React.createElement(React.Fragment, null,
                            React.createElement(uitk_react_layout_grid_1.UitkLayoutGridItem, { colSpan: { small: 4, medium: 6, large: 10, extra_large: 10 } },
                                React.createElement("div", { className: "align-left" },
                                    React.createElement("span", null,
                                        React.createElement(component_1.SwitchLocationText, { textValue: bannerModelV1.switchLocationText })),
                                    React.createElement(component_1.SwitchActionText, { textValue: bannerModelV1.switchPOSActionText }))),
                            React.createElement(uitk_react_layout_grid_1.UitkLayoutGridItem, { colSpan: { small: 2, medium: 1, large: 1, extra_large: 1 } },
                                React.createElement("span", { className: "highlight-button" },
                                    React.createElement(uitk_react_button_1.UitkSecondaryButton, { id: "switch", isFullWidth: true, size: uitk_react_button_1.UitkButtonSize.SMALL, onClick: this.redirectToTargetPOS }, bannerModelV1.switchButtonLabel))),
                            React.createElement(uitk_react_layout_grid_1.UitkLayoutGridItem, { colSpan: { small: 2, medium: 1, large: 1, extra_large: 1 } },
                                React.createElement("span", { className: "left-span" },
                                    React.createElement(uitk_react_button_1.UitkSecondaryButton, { id: "stay", isFullWidth: true, size: uitk_react_button_1.UitkButtonSize.SMALL, onClick: this.stayOnSamePageAndTrack }, bannerModelV1.stayButtonLabel))))))));
        }
        return React.createElement(React.Fragment, null);
    };
    RedirectBannerV1.prototype.stayOnSamePageAndTrack = function () {
        this.hideBannerDialog();
        this.paUtility.trackBannerAction(utils_1.ReferrerType.TRACK_CLOSE_BANNER);
    };
    RedirectBannerV1.prototype.getMIDAppendedURL = function () {
        var _this = this;
        var bannerModelV1 = this.props.bannerModelV1;
        var redirectHref = bannerModelV1.redirectHref || '';
        var adobeMIDURLPromise = this.paUtility.appendAdobeMIDToURL(redirectHref);
        adobeMIDURLPromise.then(function (response) {
            _this.setState({ redirectHref: response });
        });
    };
    return RedirectBannerV1;
}(React.Component));
exports.RedirectBannerV1 = RedirectBannerV1;
//# sourceMappingURL=redirect-banner-v1.js.map